import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
} from "@mui/material";

const defaults = {
  name: "",
  zone: "",
  effectiveFrom: "",
};

const RateCardDialog = ({ open, onOpenChange, onSubmit, initial, title }) => {
  const [form, setForm] = useState(initial || defaults);

  const handleOpen = () => setForm(initial || defaults);

  const handleSubmit = () => {
    if (!form.name.trim()) return;
    onSubmit(form);
    onOpenChange(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      slotProps={{ transition: { onEnter: handleOpen } }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Rate Card Name *"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            size="small"
            fullWidth
            slotProps={{ htmlInput: { maxLength: 100 } }}
          />
          <TextField
            label="Zone"
            value={form.zone}
            onChange={(e) => setForm({ ...form, zone: e.target.value })}
            size="small"
            fullWidth
            placeholder="e.g. Metro, Regional"
            slotProps={{ htmlInput: { maxLength: 50 } }}
          />
          <TextField
            label="Effective From"
            type="date"
            value={form.effectiveFrom}
            onChange={(e) =>
              setForm({ ...form, effectiveFrom: e.target.value })
            }
            size="small"
            fullWidth
            slotProps={{ inputLabel: { shrink: true } }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!form.name.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RateCardDialog;
